import { Cookie } from "@livelybone/storage";

/**
 * key of localStorage, don't change if not necessary!!
 * */
const key = "LANG";

const storage = Cookie;

export const langs = [
  { name: "简体中文", value: "zh-hans" },
  { name: "繁体中文", value: "zh-hant" },
  { name: "English", value: "en" },
];

export const langKeys = langs.map((l) => l.value);

export function getLangSync() {
  const lang = storage.get(key);
  if (!lang) return langs[0].value;
  if (langs.some((l) => l.value === lang)) return lang;
  return langs[0].value;
}

export function getLang() {
  return Promise.resolve(getLangSync());
}

export function setLang(val) {
  return getLang().then((lang) => {
    if (val === lang) return "";
    if (langs.some((l) => l.value === val)) {
      storage.set(key, val);
      return "Language set successful";
    }
    throw new Error("The language you want to set doesn't exist");
  });
}

function getBrowserLang() {
  if (typeof window === "undefined") return "en";
  const language =
    window.INIT_STATE &&
    window.INIT_STATE.siteInfo &&
    window.INIT_STATE.siteInfo.language;
  const lang =
    language &&
    langKeys.find((l) => l.toLowerCase() === language.toLowerCase());
  if (lang) return lang;
  return (navigator.language || navigator.userLanguage).toLowerCase() ===
    "zh-cn"
    ? "zh-hans"
    : "en";
}

export const browserLang = getBrowserLang();
